import qs from "qs";
import { RefinanceClient } from "./refinance";
import { SellAndRentClient } from "./sell-and-rent";

export class HomeClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/homes`;

    this.refinance = new RefinanceClient(this.httpClient, this.baseURL);
    this.sellAndRent = new SellAndRentClient(this.httpClient, this.baseURL);
  }

  async search(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/search${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }
}
